import { uploadToCloudinary, CloudinaryUploadResult, UploadProgress } from './cloudinaryUpload';

/**
 * Upload a recorded video/audio Blob to Cloudinary.
 *
 * Converts the Blob into a File (required by uploadToCloudinary),
 * then uploads it to the recordings folder.
 *
 * @param blob - The video/audio Blob from MediaRecorder
 * @param capsuleSlug - The capsule slug (used as folder path)
 * @param onProgress - Optional upload progress callback
 * @returns The Cloudinary upload result (includes secureUrl)
 */
export async function uploadRecording(
  blob: Blob,
  capsuleSlug: string,
  onProgress?: (progress: UploadProgress) => void
): Promise<CloudinaryUploadResult> {
  // Determine file extension from MIME type
  const ext = blob.type.includes('mp4') ? 'mp4' : 'webm';
  const filename = `submission-${Date.now()}.${ext}`;

  const file = new File([blob], filename, { type: blob.type });
  const folder = `fingerstyle/recordings/${capsuleSlug}`;

  return uploadToCloudinary(file, folder, onProgress);
}
